import { z } from 'zod';

import { getFullImagePath } from 'utils/common/get-cuverse-image-path';
import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const MinerDataResponseSchema = z
  .object({
    data: z.array(
      z.object({
        id: z.number(),
        model: z.string(),
        picture: z.string(),
        coin: z.string(),
        code: z.string(),
        hashrate: z.number(),
        unit_symbol: z.string(),
        price: z.number(),
        old_price: z.number(),
        period: z.number(),
        sort: z.number(),
        soldout: z.number(),
        sell_leader: z.number(),
        starts_at: z.number(),
        start_delay: z.number().or(z.string()).nullable(),
        count: z.number(),
        cashback: z.number(),
        is_new: z.number(),
        power_consumption: z.number(),
        efficiency: z.string(),
        price_per_kw: z.string(),
        daily_electricity_fee: z.number(),
        management_fee: z.string(),
        est_daily_output: z.number(),
        pool_name: z.string(),
        is_trial: z.boolean(),
      }),
    ),
  })
  .transform(transformKeysToCamelCase)
  .transform((data) => {
    return {
      ...data,
      data: data.data.map((item) => ({
        ...item,
        picture: getFullImagePath(item.picture),
      })),
    };
  });

export type TMinerDataResponseSchema = z.infer<typeof MinerDataResponseSchema>;
export type TMinersData = TMinerDataResponseSchema['data'];
export type TMinerData = TMinersData[number];
